import React from 'react'
import { useTranslation } from 'react-i18next'

import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Button,
  CircularProgress,  
} from '@material-ui/core'

import { CloseRounded as CloseIcon } from '@material-ui/icons'

import { useTheme } from '@material-ui/core/styles'

import Typography from '../../../atoms/display/typography'

const AlertLogoutByManager = (props) => {
  const { t } = useTranslation()
  const theme = useTheme()

  return (
    <>
      <Dialog
        fullWidth
        maxWidth="xs"
        open={props.open ? true : false}
        disableBackdropClick={props.disableBackdropClick}
        disableEscapeKeyDown={props.disableEscapeKeyDown}
        onClose={() => {}}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">
          <div
            style={{
              width: '100%',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <div>{props.title}</div>            
          </div>
        </DialogTitle>
        <DialogContent>
          <Typography variant="body1">{props.text}</Typography>
          {props.children}
        </DialogContent>
        <DialogActions>          
          <Button
            size="large"
            variant="contained"
            color="primary"
            onClick={() => props.agreeAction()}
            disabled={props?.loading || props?.disabledButton}
          >
            {props.loading ? (
              <CircularProgress size={25} color="primary" />
            ) : props.agreeText ? (
              props.agreeText
            ) : (
              t('buttons.ok')
            )}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

export default React.memo(AlertLogoutByManager)
